import { useState } from "react";
import { StockFilters } from "./StockFilters";
import { StockHeaderActions } from "./header/StockHeaderActions";
import { StockRestockDialog } from "./header/StockRestockDialog";

interface StockHeaderProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  selectedCategory: string;
  setSelectedCategory: (category: string) => void;
  onOpenAddDialog: () => void;
  onOpenDeleteDialog: () => void;
  onOpenCart: () => void;
  onOpenLossDialog: () => void;
  stockItems: any[];
  onRestockClick: (item: any) => void;
  refetch: () => void;
  onInventoryStart: () => void;
  onInventoryComplete: () => void;
  isInventoryActive: boolean;
  buttonVisibility: {
    cart: boolean;
    restock: boolean;
    return: boolean;
    quantity: boolean;
    actions: boolean;
    inventory: boolean;
    loss: boolean;
    delete: boolean;
    add: boolean;
  };
}

export const StockHeader = ({
  searchQuery,
  setSearchQuery,
  selectedCategory,
  setSelectedCategory,
  onOpenAddDialog,
  onOpenDeleteDialog,
  onOpenCart,
  onOpenLossDialog,
  stockItems,
  onRestockClick,
  refetch,
  onInventoryStart,
  onInventoryComplete,
  isInventoryActive,
  buttonVisibility,
}: StockHeaderProps) => {
  const [isRestockDialogOpen, setIsRestockDialogOpen] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState("");
  const [restockQuantity, setRestockQuantity] = useState("");
  const [productSearchQuery, setProductSearchQuery] = useState("");

  const handleInventoryComplete = () => {
    onInventoryComplete();
    refetch();
  };

  const filteredProducts = stockItems?.filter(item => {
    const productName = item.data.name?.toLowerCase() || '';
    return productName.includes(productSearchQuery.toLowerCase());
  });

  const handleRestockConfirm = () => {
    const selectedItem = stockItems.find(item => item.id === selectedProductId);
    if (selectedItem) {
      onRestockClick(selectedItem);
      setIsRestockDialogOpen(false);
      setSelectedProductId("");
      setRestockQuantity("");
      setProductSearchQuery("");
    }
  };

  return (
    <div className="space-y-4">
      <StockHeaderActions
        onOpenDeleteDialog={onOpenDeleteDialog}
        onOpenAddDialog={onOpenAddDialog}
        onOpenRestockDialog={() => setIsRestockDialogOpen(true)}
        onOpenCart={onOpenCart}
        onOpenLossDialog={onOpenLossDialog}
        stockItems={stockItems}
        onInventoryComplete={handleInventoryComplete}
        onInventoryStart={onInventoryStart}
        isInventoryActive={isInventoryActive}
        buttonVisibility={buttonVisibility}
      />

      {!isInventoryActive && (
        <StockFilters
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
        />
      )}

      <StockRestockDialog
        isOpen={isRestockDialogOpen}
        onOpenChange={setIsRestockDialogOpen}
        selectedProductId={selectedProductId}
        setSelectedProductId={setSelectedProductId}
        restockQuantity={restockQuantity}
        setRestockQuantity={setRestockQuantity}
        productSearchQuery={productSearchQuery}
        setProductSearchQuery={setProductSearchQuery}
        handleRestockConfirm={handleRestockConfirm}
        filteredProducts={filteredProducts}
      />
    </div>
  );
};